import { type FC } from "react";
import { type GetFamilyCustomerAddressesPagesSettingsShipmentQuery } from "@/pages/settings/shipment/__gql__/get-family-customer-address.gen";
import { UserInfo } from "@/components/fragments/userinfo";
import { primaryFamilyCustomerUserNameTestId } from "./const";

interface Props {
  primaryFamilyCustomerAddress:
    | GetFamilyCustomerAddressesPagesSettingsShipmentQuery["familyCustomer"]["primaryFamilyCustomerAddress"]
    | undefined;
}

export const PrimaryFamilyCustomerUserName: FC<Props> = ({ primaryFamilyCustomerAddress }) => {
  return (
    <UserInfo
      as="a"
      w="100%"
      type="simple"
      user={{
        lastName: primaryFamilyCustomerAddress?.lastName ?? "",
        firstName: primaryFamilyCustomerAddress?.firstName ?? "",
      }}
      data-testid={primaryFamilyCustomerUserNameTestId}
    />
  );
};
